/**
 * 說明 : 控制信號資料與後端API調用的非同步行為
 */
import { createAsyncThunk } from "@reduxjs/toolkit";

import BaseAPI from "./BaseAPI";

// 新增梯控信號
export const addControlCode = createAsyncThunk(
    "controlCode/addControlCode",
    async (controlCode, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token;
            const data = await BaseAPI.postWithAuth("/setting/controlCode", controlCode, token);
            return data;
        } catch (err) {
            console.error('add control code error', err.response.data);
            return rejectWithValue(err.response.data);
        }
    }
);

// 修改梯控信號
export const editControlCode = createAsyncThunk(
    "controlCode/editControlCode",
    async (controlCode, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token;
            const data = await BaseAPI.putWithAuth("/setting/controlCode", controlCode, token);
            return data;
        } catch (err) {
            console.error('edit control code error', err.response.data);
            return rejectWithValue(err.response.data);
        }
    }
);

// 刪除梯控信號
export const deleteControlCode = createAsyncThunk(
    "controlCode/deleteControlCode",
    async (controlIds, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token;
            const data = await BaseAPI.deleteWithAuth(`/setting/controlCode/${controlIds}`, null, token);
            return data;
        } catch (err) {
            console.error('delete control code error', err.response.data);
            return rejectWithValue(err.response.data);
        }
    }
);

// 取得單筆梯控信號
export const fetchControlCode = createAsyncThunk(
    "controlCode/fetchControlCode",
    async (controlId, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token;
            const data = await BaseAPI.getWithAuth(`/setting/controlCode/${controlId}`, null, token);
            return data;
        } catch (err) {
            console.error('fetch control code error', err.response.data);
            return rejectWithValue(err.response.data);
        }
    }
);

// 取得梯控信號清單列表
export const fetchControlCodeList = createAsyncThunk(
    "controlCode/fetchControlCodeList",
    async ({ controlCode, controlType }, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token;
            const data = await BaseAPI.getWithAuth("/setting/controlCode", { controlCode: controlCode, controlType: controlType }, token);
            return data;
        } catch (err) {
            console.error('fetch control code list error', err.response.data);
            return rejectWithValue(err.response.data);
        }
    }
);